import { CustomVideoPlayer, DocumentFileIcon, MicrophoneIcon } from '@room-match/shared-ui-components';
import { useEffect, useState } from 'react';
import { IOutput, IProfileMediaSetSelectPayload } from 'shared/interfaces/IProfile';
import { IOnProgress } from 'shared/interfaces/utils/IAxios';
import { uploadService } from 'shared/services/uploadService';
import {
  AudioInfo,
  AudioItemCont,
  AudioName,
  Duration,
  ImageElement,
  ImageItemCont,
  useStyles,
  VideoItemCont,
} from './item.styles';
import { ProgressOverlay } from 'components/Progressoverlay/ProgressOverlay';
import { DocumentContainer, DocumentIconContainer, DocumentName } from './Document/Document.styles';
interface Props {
  type: 'image' | 'video' | 'audio' | 'document';
  data: any;
  bindToProfile?: (data: IProfileMediaSetSelectPayload, id: string) => void;
  id: string;
  handleUploadComplete?: () => void;
}
const { uploadMedia } = uploadService();

function UploadingItem({ type, data, bindToProfile, id, handleUploadComplete }: Props) {
  const { mutateAsync: uploadMediaMutateAsync, isLoading: uploadMediaMutateLoading } = uploadMedia();
  const [audio] = useState(new Audio(type === 'audio' ? URL.createObjectURL(data) : ''));
  const [duration, setduration] = useState(0);
  const [progress, setprogress] = useState(0);
  const classes = useStyles({});

  const onProgres: IOnProgress = (progress: number) => {
    setprogress(progress);
  };

  const handleUpload = async (image: IOutput) => {
    const formData = new FormData();

    const {
      attachment,
      attachment_size,
      file_name,
      file_width,
      file_height,
      file_type,
      file_size,
      tag_list,
      modified_attachment,
      modified_metadata,
    } = image;

    if (type === 'image') {
      formData.set('attachment', attachment);
      formData.set('modified_attachment', modified_attachment as any);
      formData.set('modified_metadata', modified_metadata as any);
      formData.set('attachment_size', attachment_size ? attachment_size.toString() : '');
      formData.append('file_name', file_name);
      formData.append('file_type', file_type);
      formData.set('file_size', file_size);
      formData.set('file_height', file_height);
      formData.set('file_width', file_width);
      formData.append('tag_list', tag_list);
      formData.append('media_bin', 'true');
    } else {
      formData.set('attachment', data);
      formData.append('file_name', data.name);
      formData.append('file_type', `${type}`);
      formData.set('file_size', data.size.toString());
      formData.append('media_bin', 'true');
    }

    const uploadedPhoto = await uploadMediaMutateAsync({ formData, onProgres });
    if (uploadedPhoto && bindToProfile) {
      bindToProfile(
        tag_list
          ? {
              id: uploadedPhoto.data.id,
              tag_list: type,
              media_tag_list: tag_list.split(','),
            }
          : {
              id: uploadedPhoto.data.id,
              tag_list: type,
            },
        id,
      );
    } else {
      console.error('Uploading Failed');
    }
    handleUploadComplete?.();
  };

  useEffect(() => {
    handleUpload(data);
  }, [data]);

  useEffect(() => {
    const getAudioInfo = (e: any) => {
      setduration(e.target.duration);
    };

    audio.addEventListener('loadedmetadata', getAudioInfo);

    return () => {
      audio.removeEventListener('loadedmetadata', getAudioInfo);
    };
  }, [audio]);

  const progressOverlay = () => <ProgressOverlay progress={progress} />;

  return type === 'image' ? (
    <ImageItemCont>
      {progressOverlay()}
      <ImageElement src={URL.createObjectURL(data.attachment)} />
    </ImageItemCont>
  ) : type === 'video' ? (
    <VideoItemCont>
      {progressOverlay()}
      <div style={{ flex: 1, height: '100%', borderRadius: 10, boxShadow: '0 0 10px 0 #2d343e' }}>
        <CustomVideoPlayer
          isSmall
          classes={{ root: 'profile-video-item', videoPlayer: '', icon: '' }}
          url={URL.createObjectURL(data)}
        />
      </div>
    </VideoItemCont>
  ) : type === 'audio' ? (
    <AudioItemCont style={{ padding: 0, overflow: 'hidden', border: '1px solid #ffffff20' }}>
      {progressOverlay()}
      <MicrophoneIcon />
      <AudioInfo>
        <AudioName>{data.name}</AudioName>
        <Duration>
          {`${'Duration : '}`}
          {duration < 3600
            ? new Date(duration * 1000).toISOString().substring(14, 19)
            : new Date(duration * 1000).toISOString().substr(11, 8)}
        </Duration>
      </AudioInfo>
    </AudioItemCont>
  ) : type === 'document' ? (
    <DocumentContainer>
      {progressOverlay()}
      <DocumentIconContainer>
        <DocumentFileIcon />
      </DocumentIconContainer>
      <DocumentName>{data.name}</DocumentName>
    </DocumentContainer>
  ) : null;
}

export default UploadingItem;
